import {
  CustomReportArgument,
  SetCustomReportDateAction,
  SET_DATE,
  SetCustomReportArgumentsAction,
  SET_ARGUMENTS,
  RemoveCustomReportArgumentAction,
  REMOVE_ARGUMENT,
  SetActiveReportIdAction,
  SET_ACTIVE_REPORT_ID
} from './types'

export const setCustomReportDate = (payload: string): SetCustomReportDateAction => ({
  type: SET_DATE,
  payload
})

export const setCustomReportArguments = (payload: CustomReportArgument[]): SetCustomReportArgumentsAction => ({
  type: SET_ARGUMENTS,
  payload
})

export const removeCustomReportArgument = (id: number): RemoveCustomReportArgumentAction => ({
  type: REMOVE_ARGUMENT,
  payload: id
})

export const setActiveReportId = (payload: number | undefined): SetActiveReportIdAction => ({
  type: SET_ACTIVE_REPORT_ID,
  payload
})
